/* eslint-disable arrow-body-style */
/* eslint-disable camelcase */
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, Grid, Typography, Button, Stack } from '@material-ui/core';
import Page from '../components/Page';
import { AddPolicyModal, PolicyTable } from '../components/admin/policy';
import { getIDToken } from '../components/authentication/login/amplify';

export default function Policies() {
  const [policyList, setPolicyList] = useState([]);
  const [addModalOpen, setModalOpen] = useState(false);

  const closeModal = () => setModalOpen(false);
  const openModal = () => setModalOpen(true);

  useEffect(() => {
    updatePolicies();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  // initial call to get racklist
  const updatePolicies = async () => {
    const jwt = await getIDToken();
    if (jwt) {
      axios
        .get(`${process.env.REACT_APP_API}/admin/policies`, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        })
        .then((response) => {
          setPolicyList(response.data);
          return response.data;
        })
        .catch((error) => {
          console.error('failed to get list of policies ', error.message);
        });
    }
  };

  return (
    <Page title="Admin | Policies | Virtual Racks">
      <AddPolicyModal
        updatePolicies={updatePolicies}
        policies={policyList}
        isOpen={addModalOpen}
        closeHandler={closeModal}
      />
      <Container maxWidth={false}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="h4">Policies</Typography>
              <Button onClick={openModal} variant="contained">
                New Policy
              </Button>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <PolicyTable
              updatePolicies={updatePolicies}
              policyList={policyList}
              // setError={setError}
            />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
